/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/button/css/button';
import '@swisslife/patterns-base/src/atoms/link/css/link';
import '@swisslife/patterns-base/src/atoms/image/css/image';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/atoms/text/css/text';
import '@swisslife/patterns-base/src/molecules/rich-text/css/rich-text';
import './text-image.scss';
import './modifier/image-left.scss';
import './modifier/image-right.scss';
import './modifier/only-image.scss';
import './modifier/only-text.scss';
import './modifier/spacing-reduced.scss';
